ngApp.controller('SocketController', ['$scope', '$socket', '$log', function ($scope, $socket, $log) {

}]);